module.exports = __webpack_public_path__ + "static/media/ambient-puzzle.b78c7881.mp3";